import m from "./../../../dist/es2015/locales/uk_UA.js";
export const am5locales_uk_UA = m;